import $ from 'jquery';
import _ from 'underscore';
import { getStorage } from '../../../home24/helpers/storage-factory';
import * as baseTracking from '../../../home24-shared/core/base-tracking';
import 'home24-jquery-validation';

/**
 * tracking of success/failed registration
 */

var storage = getStorage();
var $el = $('body');
var $forms;

const register = _.extend({
    setCookie: function (data) {
        storage.set('GtmOnLoginPageRegisterSuccess', data);
    },

    cookieCallbacks: {
        GtmOnLoginPageRegisterSuccess: 'afterRegistration'
    },

    init: function () {
        $el.find('.js-open-registration').on('click', $.proxy(this.onRegisterFormOpenButtonClick, this));
        $forms = $el.find('.js-register-form-private, .js-register-form-business');
        $forms.on('submit.registerEvents', $.proxy(this.onRegisterFormSubmit, this));
    },

    onRegisterFormSubmit: function (event) {

        var $form = $(event.currentTarget);
        var validator = $form.validate();

        if (validator.valid()) {
            this.onRegistrationSuccess($form);
        } else {
            this.onRegistrationFailed($form, validator);
        }
    },

    onRegistrationFailed: function ($form, validator) {
        var dataLayerObject = {
            event: 'reg_failed',
            err_text: []
        };

        // serialize error messages
        validator.errorList.forEach(function (item) {
            dataLayerObject.err_text.push({
                name: item.element.name,
                message: item.message
            });
        });

        window.dataLayer.push(dataLayerObject);
    },

    onRegistrationSuccess: function ($form) {

        // gather data
        var dataLayerObject = {
            event: 'register',
            gender: $form.find('[name="prefix"]').filter(':checked').val(),
            customer_type: $form.find('[name="customer_type"]').val(),
            newsletter: $form.find('[name="subscribe_to_newsletter"]').is(':checked')
        };

        this.setCookie(dataLayerObject);
    },

    onRegisterFormOpenButtonClick: function (event) {
        window.dataLayer.push({
            event: 'register_button',
            button: event.currentTarget.innerHTML.trim()
        });
    },

    afterRegistration: function (cookieValue) {
        // are we on next page after registration?
        // check if no server side validation errors
        if (this.areServerSideErrors()) {
            this.onServerRegistrationFailed();
        } else {
            // all fine from the server
            window.dataLayer.push(cookieValue);
        }
    },

    getErrors: function () {
        return $el.find('.messages').find('.error');
    },

    areServerSideErrors: function () {
        return this.getErrors().length;
    },

    onServerRegistrationFailed: function () {

        var dataLayerObject = {
            event: 'reg_failed',
            err_text: []
        };

        // read server side errors
        this.getErrors().each(function (index, element) {
            dataLayerObject.err_text.push({
                name: 'serverError',
                message: $(element).text()
            });
        });

        window.dataLayer.push(dataLayerObject);
    },

    destroy: function () {
        $forms.off('.registerEvents');
    }

}, baseTracking);

export function init() {
    return register.init();
}

export function executeCookieCallbacks() {
    return register.executeCookieCallbacks();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/login/register.js
 **/